import React, { useState } from "react";
import home1 from "../assets/images/h1.jpg";
import home2 from "../assets/images/h2.jpg";
import { ModalComp, CameraView } from "./";
import { useTranslation } from "react-i18next";
const Camera = () => {
  const { t } = useTranslation();
  const [openCameraViewModal, setOpenCameraViewModal] = useState(false);
  const toggleCameraView = () => setOpenCameraViewModal(!openCameraViewModal);

  return (
    <div>
      {/* <ModalComp
                modal={openCameraViewModal}
                toggle={toggleCameraView}
                component={<CameraView />}
            /> */}
      {!openCameraViewModal ? (
        <>
          <div className="d-flex align-items-center weatherStatus">
            <i className="circleTop icon-plug text-center"></i>
            <div className="text-center mx-4">
              <p className="m-0">{t("دوربین")}</p>
            </div>
          </div>
          <div style={{ minHeight: "65vh" }}>
            <div
              className="d-flex flex-wrap justify-content-center mt-4"
              style={{ overflow: "auto", height: "66vh" }}
            >
              <div className="col-lg-6 col-md-6 mb-4">
                <div className="parkingItems cursor" onClick={toggleCameraView}>
                  <div className="bg-white d-flex justify-content-between align-items-center p-2">
                    <p className="m-0 fn">{t("اتاق خواب")}</p>
                    <p className="m-0 fn12 muted">{t("14 دقیقه پیش")}</p>
                  </div>
                  <div className="h-100">
                    <img src={home1} className="w-100 h-100" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 mb-4">
                <div className="parkingItems cursor" onClick={toggleCameraView}>
                  <div className="bg-white d-flex justify-content-between align-items-center p-2">
                    <p className="m-0 fn">{t("اتاق نشیمن")}</p>
                    <p className="m-0 fn12 muted">{t("14 دقیقه پیش")}</p>
                  </div>
                  <div className="h-100">
                    <img src={home2} className="w-100 h-100" />
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex flex-wrap justify-content-center mt-3 mb-2">
              <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
                <span className="profileAddUser bg-white d-block cursor icon-seti"></span>
                <small className="fn10 mt-1">{t("تنظیمات")}</small>
              </div>
              <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
                <span className="profileAddUser bg-white d-block cursor icon-off"></span>
                <small className="fn10 mt-1">{t("خاموش")}</small>
              </div>
              <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
                <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
                <small className="fn10 mt-1">{t("بازگشت")}</small>
              </div>
            </div>
          </div>
        </>
      ) : (
        <CameraView />
      )}
    </div>
  );
};

export { Camera };
